// src/pages/Asset.js
import React, { useState, useEffect } from "react";
import { toastSuccess }  from "../utils/toast";
import { BuyUswd }       from "../components/buyuswd";
import { BuyGhsx }       from "../components/buyghsx";
import { SendUswd }      from "../components/senduswd";
import SendUsdtInternal  from "./SendUsdtInternal";
import UsdtSend          from "./UsdtSend";
import { SendGhsx } from "../components/sendghsx";

export default function Asset({
  wallet,
  socket,         // needed by SendGhsx
  usdt,
  usdtSocket,     // passed through to UsdtSend
  onMarket,
  uswdSocket,
  ghsxSocket,
   myChatId,  
    onBack,
    onTransactions,
 ghsxWallet:       ghsxWalletProp       = null,
uswdWallet:       uswdWalletProp       = null,
uswdPricing = null,
ghsxPricing = null,
uswdLoading:      uswdLoadingProp      = true,
  uswdError:        uswdErrorProp        = null,
  isApprovedSeller: isApprovedSellerProp = false,
  onRefreshUswdBalance,
  onRefreshGhsxBalance,
   onUswdPurchaseSuccess,
    usdtSendSuccessRef,
    usdtSendErrorRef,
mobileView,
initialPanel = null,
}) {
  const ghsxWallet       = ghsxWalletProp;
  const uswdWallet       = uswdWalletProp;
  const uswdLoading      = uswdLoadingProp;
  const uswdError        = uswdErrorProp;
  const isApprovedSeller = isApprovedSellerProp;

  /*
   * activePanel:
   *   null               → main asset view
   *   "buy-uswd"         → BuyUswd component
   *   "buy-ghsx"         → BuyGhsx component
   *   "send-uswd"        → SendUswd component
   *   "send-ghsx"          → SendGhsx component
   *   "send-usdt-internal" → SendUsdtInternal component
   *   "send-usdt-onchain"  → UsdtSend component
   */
 const [activePanel, setActivePanel] = useState(null);
const [sendMode, setSendMode] = useState(null);
const [showSendModal, setShowSendModal] = useState(false);

  const hasGhsxData = ghsxWallet?.balance !== undefined || ghsxWallet?.ghsxAddress;
  const hasUswdData = uswdWallet?.balance !== undefined || uswdWallet?.uswdAddress;
  const hasUsdtData = usdt?.address || usdt?.balance !== undefined;
  const hasAnyData  = hasGhsxData || hasUswdData || hasUsdtData || uswdLoading;

  const copyValue = async (value, label) => {
    await navigator.clipboard.writeText(String(value));
    toastSuccess(`${label} copied`);
  };

  const handleRefresh  = () => onRefreshUswdBalance?.();
  const closePanel     = () => setActivePanel(null);
  const closeSendModal = () => { setShowSendModal(false); setSendMode(null); };

  /* ================= LOADING ================= */
  if (!hasAnyData) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="rounded-lg bg-neutral-100 px-6 py-4 dark:bg-neutral-700">
          Loading wallet…
        </div>
      </div>
    );
  }

  /* ================= BUY USWD panel ================= */
 if (activePanel === "buy-uswd") {
    return (
   <BuyUswd
  chatId={myChatId}
  usdt={usdt}
  uswdPricing={uswdPricing}
  onBack={closePanel}
  onSuccess={onUswdPurchaseSuccess || handleRefresh}
/>
    );
  }

  /* ================= BUY GHSX panel ================= */
  if (activePanel === "buy-ghsx") {
    return (
     <BuyGhsx
  chatId={myChatId}
  usdt={usdt}
  ghsxPricing={ghsxPricing}
  onBack={closePanel}
  onSuccess={onRefreshGhsxBalance || handleRefresh}
/>
    );
  }

  /* ================= SEND USWD panel ================= */
  if (activePanel === "send-uswd") {
    return (
      <SendUswd
        uswdWallet={uswdWallet}
        uswdSocket={uswdSocket}  
        onBack={closePanel}
        onSuccess={handleRefresh}
      />
    );
  }

 
/* ================= SEND GHSX panel ================= */

if (activePanel === "send-ghsx") {
  return (
    <SendGhsx
      socket={socket}
      ghsxWallet={ghsxWallet}
      ghsxSocket={ghsxSocket}
      onBack={closePanel}
      onSuccess={onRefreshGhsxBalance}
    />
  );
}
  /* ================= SEND USDT (Internal) panel ================= */
   /* ================= SEND USDT (Internal) panel ================= */
  if (activePanel === "send-usdt-internal") {
    return (
   <SendUsdtInternal
  wallet={{ chatId: myChatId }}
  usdtSocket={usdtSocket}
  usdtBalance={usdt}
  available={Number(usdt?.available ?? 0)}
  onBack={closePanel}
  mobileView={mobileView}
  onSendSuccess={usdtSendSuccessRef}
  onSendError={usdtSendErrorRef}
/>
    );
  }

  /* ================= SEND USDT (On-chain) panel ================= */
  if (activePanel === "send-usdt-onchain") {
    return (
    <UsdtSend
     wallet={{ chatId: myChatId }}
  usdtSocket={usdtSocket}
  usdtBalance={usdt}
  onBack={closePanel}
     onSendSuccess={usdtSendSuccessRef}
onSendError={usdtSendErrorRef}
mobileView={mobileView}
/>
    );
  }

  /* ============================================================
     VIEW: asset (default)
  ============================================================ */
  return (
  <div
    className="flex h-full w-full flex-col overflow-y-auto p-4"
    style={mobileView ? { paddingTop: "max(16px, env(safe-area-inset-top, 16px))" } : {}}
  >
    {/* ================= SEND ================= */}
<div className="mb-3 flex justify-end">
  <button
    type="button"
    onClick={() => setShowSendModal(true)}
    className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium
               text-white transition-colors hover:bg-blue-700 shrink-0"
  >
    Send
  </button>
</div>
    {/* ================= GHSX ================= */}
    <div className="mb-4 rounded-xl border bg-white p-4 shadow-sm
                    dark:border-neutral-700 dark:bg-neutral-800">

    <div className="mb-3 flex items-center justify-between">
  <span className="text-sm font-medium">GHSX · Metisel Wallet</span>

  {hasGhsxData && (
    <div className="flex gap-2">
      <button
        onClick={() => setActivePanel("buy-ghsx")}
        className="rounded-lg bg-green-600 px-3 py-2 text-xs text-white hover:bg-green-700
                   active:bg-green-800 touch-manipulation"
      >
        Buy GHSX
      </button>
    </div>
  )}
</div>

      {uswdLoading ? (
        <div className="text-sm text-neutral-400">Loading balance...</div>
      ) : hasGhsxData ? (
        <>
          <div
            role={onTransactions ? "button" : undefined}
            tabIndex={onTransactions ? 0 : undefined}
            onClick={() => onTransactions?.("ghsx")}
            onKeyDown={(e) => {
              if (onTransactions && (e.key === "Enter" || e.key === " ")) {
                e.preventDefault();
                onTransactions("ghsx");
              }
            }}
            className={`space-y-1 text-sm rounded-lg -mx-2 px-2 py-1 transition-colors ${
              onTransactions
                ? "cursor-pointer hover:bg-neutral-50 active:bg-neutral-100 dark:hover:bg-neutral-700/50 dark:active:bg-neutral-700 touch-manipulation"
                : ""
            }`}
          >
            <div className="flex justify-between">
              <span>Total</span>
              <strong>{Number(ghsxWallet.balance).toFixed(2)} GHSX</strong>
            </div>

            <div className="flex justify-between text-yellow-600">
              <span>Committed</span>
              <strong>{Number(ghsxWallet.committed).toFixed(2)} GHSX</strong>
            </div>

            <div className="flex justify-between text-green-600">
              <span>Available</span>
              <strong>{Number(ghsxWallet.available).toFixed(2)} GHSX</strong>
            </div>
          </div>

          {ghsxWallet.ghsxAddress && (
            <div className="mt-3 flex items-center gap-2">
              <code className="truncate text-xs">{ghsxWallet.ghsxAddress}</code>

              <button
                onClick={() => copyValue(ghsxWallet.ghsxAddress, "GHSX address")}
                className="rounded border px-3 py-2 text-xs dark:border-neutral-600
                           active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
              >
                Copy
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="text-sm text-neutral-400">No GHSX wallet found</div>
      )}
    </div>

    {/* ================= USWD ================= */}
    <div className="mb-4 rounded-xl border bg-white p-4 shadow-sm
                    dark:border-neutral-700 dark:bg-neutral-800">

       <div className="mb-3 flex items-center justify-between">
          <span className="text-sm font-medium">USWD · Metisel Wallet</span>

       {hasUswdData && (
  <div className="flex gap-2">
    <button
      onClick={() => setActivePanel("buy-uswd")}
      className="rounded-lg bg-green-600 px-3 py-2 text-xs text-white hover:bg-green-700
                 active:bg-green-800 touch-manipulation"
    >
      Buy USWD
    </button>
  </div>
)}
        </div>

        {uswdLoading ? (
          <div className="text-sm text-neutral-400">Loading balance…</div>
        ) : uswdError ? (
          <div className="text-sm text-red-500">{uswdError}</div>
        ) : hasUswdData ? (
          <>
            <div
              role={onTransactions ? "button" : undefined}
              tabIndex={onTransactions ? 0 : undefined}
              onClick={() => onTransactions?.("uswd")}
              onKeyDown={(e) => {
                if (onTransactions && (e.key === "Enter" || e.key === " ")) {
                  e.preventDefault();
                  onTransactions("uswd");
                }
              }}
              className={`space-y-1 text-sm rounded-lg -mx-2 px-2 py-1 transition-colors ${
                onTransactions
                  ? "cursor-pointer hover:bg-neutral-50 active:bg-neutral-100 dark:hover:bg-neutral-700/50 dark:active:bg-neutral-700 touch-manipulation"
                  : ""
              }`}
            >
              <div className="flex justify-between">
                <span>Total</span>
                <strong>{Number(uswdWallet.balance).toFixed(2)} USWD</strong>
              </div>
              <div className="flex justify-between text-yellow-600">
                <span>Committed</span>
                <strong>{Number(uswdWallet.committed).toFixed(2)} USWD</strong>
              </div>
              <div className="flex justify-between text-green-600">
                <span>Available</span>
                <strong>{Number(uswdWallet.available).toFixed(2)} USWD</strong>
              </div>
              {uswdWallet.commission > 0 && (
                <div className="flex justify-between text-blue-600">
                  <span>Commission</span>
                  <strong>{Number(uswdWallet.commission).toFixed(2)} USWD</strong>
                </div>
              )}
              {uswdWallet.sellRate > 0 && (
                <div className="flex justify-between text-xs text-neutral-500 pt-1">
                  <span>Sell rate</span>
                  <span>{uswdWallet.sellRate}</span>
                </div>
              )}
            </div>

            {uswdWallet.uswdAddress && (
              <div className="mt-3 flex items-center gap-2">
                <code className="truncate text-xs">{uswdWallet.uswdAddress}</code>
                <button
                  onClick={() => copyValue(uswdWallet.uswdAddress, "USWD address")}
                  className="rounded border px-3 py-2 text-xs dark:border-neutral-600
                             active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
                >
                  Copy
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="text-sm text-neutral-400">No USWD wallet found</div>
        )}
      </div>

      {/* ================= USDT ================= */}
      {usdt?.address && (
        <div className="mb-4 rounded-xl border bg-white p-4 shadow-sm
                        dark:border-neutral-700 dark:bg-neutral-800">
          <div className="mb-3 text-sm font-medium">Tether (USDT) · Solana</div>

          <div
            role={onTransactions ? "button" : undefined}
            tabIndex={onTransactions ? 0 : undefined}
            onClick={() => onTransactions?.("usdt")}
            onKeyDown={(e) => {
              if (onTransactions && (e.key === "Enter" || e.key === " ")) {
                e.preventDefault();
                onTransactions("usdt");
              }
            }}
            className={`space-y-1 text-sm rounded-lg -mx-2 px-2 py-1 transition-colors ${
              onTransactions
                ? "cursor-pointer hover:bg-neutral-50 active:bg-neutral-100 dark:hover:bg-neutral-700/50 dark:active:bg-neutral-700 touch-manipulation"
                : ""
            }`}
          >
          <div className="flex justify-between">
  <span>Total</span>
  <strong>{Number(usdt?.balance ?? 0).toFixed(2)} USDT</strong>
</div>
<div className="flex justify-between text-yellow-600">
  <span>Committed</span>
  <strong>{Number(usdt?.committed ?? 0).toFixed(2)} USDT</strong>
</div>
<div className="flex justify-between text-green-600">
  <span>Available</span>
  <strong>{Number(usdt?.available ?? 0).toFixed(2)} USDT</strong>
</div>
          </div>

          <div className="mt-3 flex items-center gap-2">
            <code className="truncate text-xs">{usdt.address}</code>
            <button
              onClick={() => copyValue(usdt.address, "USDT address")}
              className="rounded border px-3 py-2 text-xs dark:border-neutral-600
                         active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
            >
              Copy
            </button>
          </div>
<p className="mt-3 text-xs text-neutral-500">
    Send only <strong>USDT (SPL)</strong> on Solana
  </p>

</div>
)}

            {/* ================= SEND MODAL ================= */}
      {showSendModal && (
        <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/40 px-0 sm:px-4">
          <div
            className="w-full sm:w-[min(420px,calc(100vw-32px))] sm:max-w-sm rounded-t-2xl sm:rounded-xl bg-white p-6 dark:bg-neutral-800"
            style={{ paddingBottom: "max(24px, env(safe-area-inset-bottom, 24px))" }}
          >

            {/* Step 1 — choose send type */}
            {!sendMode && (
              <>
                <h3 className="mb-4 text-lg font-semibold">How do you want to send?</h3>
                <button
                  onClick={() => setSendMode("internal")}
                  className="mb-3 w-full rounded-lg border py-3 dark:border-neutral-600
                             active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
                >
                  Send to Metisel users
                </button>
                <button
                  onClick={() => setSendMode("onchain")}
                  className="w-full rounded-lg border py-3 dark:border-neutral-600
                             active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
                >
                  On-chain withdraw
                </button>
              </>
            )}

            {/* Step 2a — internal: pick asset */}
            {sendMode === "internal" && (
              <>
                <h3 className="mb-4 text-lg font-semibold">Select asset</h3>

                {hasGhsxData && (
                <button
  onClick={() => {
    closeSendModal();
    setActivePanel("send-ghsx");
  }}
  className="mb-3 w-full rounded-lg border py-3 dark:border-neutral-600
             active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
>
  Send GHSX
</button>
                )}

                {hasUswdData && (
                 <button
  onClick={() => {
    closeSendModal();
    setActivePanel("send-uswd");
  }}
  className="mb-3 w-full rounded-lg border py-3 dark:border-neutral-600
             active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
>
  Send USWD
</button>
                )}

                {hasUsdtData && (
                <button
  onClick={() => {
    closeSendModal();
    setActivePanel("send-usdt-internal");
  }}
  className="w-full rounded-lg border py-3 dark:border-neutral-600
             active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
>
  Send USDT
</button>
                )}
              </>
            )}

            {/* Step 2b — on-chain: pick asset */}
            {sendMode === "onchain" && (
              <>
                <h3 className="mb-4 text-lg font-semibold">Select asset</h3>

                {usdt?.address && (
                  <button
                    onClick={() => {
                      closeSendModal();
                      setActivePanel("send-usdt-onchain");
                    }}
                    className="w-full rounded-lg border py-3 dark:border-neutral-600
                               active:bg-neutral-100 dark:active:bg-neutral-700 touch-manipulation"
                  >
                    USDT
                  </button>
                )}
              </>
            )}

            <button
              onClick={closeSendModal}
              className="mt-4 w-full py-2 text-sm text-neutral-500
                         active:text-neutral-700 dark:active:text-neutral-300 touch-manipulation"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

    </div>
  );
}